export default "__VITE_ASSET__CLjzOWRK__"